/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Dropdown,
  Select,
  notification,
  Radio,
  Space,
  Menu, Drawer, Alert,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilePdf, faCaretDown, faPenToSquare, faDownload,
} from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import InvoiceActions from '@Actions/invoiceActions';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;
/**
 *
 */
function BulkInvoiceActions({
  invoices, updateInvoiceStatus, downloadInvoice, downloadInvoiceLoading, downloadShippingLabelsLoading,
  selectedRows, selectedRowKeys, callback, updateInvoiceStatusLoading, downloadShippingLabels, user,
}) {
  const [openInvoiceDownload, setOpenInvoiceDownload] = useState(false);
  const [openInvoiceShippingLabels, setOpenInvoiceShippingLabels] = useState(false);
  const [downloadFileType, setDownloadFileType] = useState('pdf');
  const [downloadSortBy, setDownloadSortBy] = useState('invoice_number');
  const [shippingLabelsDownloadFileType, setShippingLabelsDownloadFileType] = useState('pdf');
  const [statusUpdate, setStatusUpdate] = useState('NO');
  const [openBulkUpdate, setOpenBulkUpdate] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isStatusSelectEnabled, setIsStatusSelectEnabled] = useState(true);
  const [withPrice, setWithPrice] = useState('');

  useEffect(() => {
    const customStatusSet = {};
    for (let i = 0; i < selectedRows?.length; i++) {
      customStatusSet[selectedRows?.[i]?.custom_status_info?.custom_status_id] = {
        name: selectedRows?.[i]?.custom_status_info?.status_name,
        type: selectedRows?.[i]?.custom_status_info?.type,
        custom_status_id: selectedRows?.[i]?.custom_status_info?.custom_status_id,
      };
    }
    if (Object.keys(customStatusSet)?.length > 1) {
      setIsStatusSelectEnabled(false);
      setSelectedStatus(customStatusSet[Object.keys(customStatusSet)?.[0]]);
    } else {
      setIsStatusSelectEnabled(true);
      setSelectedStatus(customStatusSet[Object.keys(customStatusSet)?.[0]]);
    }
  }, [selectedRowKeys]);

  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: item?.invoice_id }));
    }
    return [];
  };

  const firstObject = getDataSource(invoices?.data?.invoices)?.[0];

  return (
    <Fragment>
      <div>
        <Dropdown
          overlay={(
            <Menu>
              <Menu.Item>
                <div onClick={() => {
                  if (downloadInvoiceLoading || !selectedRowKeys?.length) {
                    notification.open({
                      placement: 'top',
                      duration: 4,
                      type: 'warning',
                      message: 'Please select one or more invoices to download',
                    });
                  } else {
                    setOpenInvoiceDownload(!openInvoiceDownload);
                  }
                }}
                >
                  <FontAwesomeIcon icon={faFilePdf} />
                            &nbsp; Download Invoices
                </div>
              </Menu.Item>
              <Menu.Item>
                <div onClick={() => {
                  if (downloadShippingLabelsLoading || !selectedRowKeys?.length) {
                    notification.open({
                      placement: 'top',
                      duration: 4,
                      type: 'warning',
                      message: 'Please select one or more invoices to download shipping labels',
                    });
                  } else {
                    setOpenInvoiceShippingLabels(!openInvoiceShippingLabels);
                  }
                }}
                >
                  <FontAwesomeIcon icon={faFilePdf} />
                            &nbsp; Shipping Labels
                </div>
              </Menu.Item>
              <Menu.Item>
                <div onClick={() => {
                  if (downloadInvoiceLoading || !selectedRowKeys?.length) {
                    notification.open({
                      placement: 'top',
                      duration: 4,
                      type: 'warning',
                      message: 'Please select one or more invoices to Update Status',
                    });
                  } else {
                    setOpenBulkUpdate(!openBulkUpdate);
                  }
                }}
                >
                  <FontAwesomeIcon icon={faPenToSquare} />
                            &nbsp; Bulk Update
                </div>
              </Menu.Item>
            </Menu>
          )}
          placement="topLeft"
          trigger={['click']}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          <div className="ba-button">
            Actions
            &nbsp;
            <FontAwesomeIcon icon={faCaretDown} />
          </div>
        </Dropdown>
      </div>
      <Drawer
        open={openInvoiceDownload}
        onClose={() => setOpenInvoiceDownload(!openInvoiceDownload)}
        width="380px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '330px' }}>
            <H3Text text="Download Invoices" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenInvoiceDownload(false)} />
          </div>
        </div>

        <div className="ba-wrapper">
          <H3Text
            text={(
              <span>
                <FontAwesomeIcon icon={faDownload} />
            &nbsp; &nbsp;
                {`${selectedRowKeys?.length} Invoices Selected`}
              </span>
            )}
            className="ba-title"
          />
          <div className="ba-input__wrapper">
            <H3Text text="Select File Format for Downloading Invoices" className="ba-input__label" />
            <Radio.Group
              onChange={(event) => setDownloadFileType(event?.target?.value)}
              disabled={downloadInvoiceLoading}
              value={downloadFileType}
              style={{ marginTop: '-10px' }}
            >
              <Space direction="vertical">
                <Radio key="1" value="pdf">Merged invoices in single PDF</Radio>
                <Radio key="2" value="zip">Individual invoices in Zip</Radio>
              </Space>
            </Radio.Group>
          </div>
          {downloadFileType === 'pdf' && (
            <div className="ba-input__wrapper">
              <H3Text text="Order Invoice By" className="ba-input__label" />
              <Radio.Group
                onChange={(event) => setDownloadSortBy(event?.target?.value)}
                disabled={downloadInvoiceLoading}
                value={downloadSortBy}
                style={{ marginTop: '-10px' }}
              >
                <Space direction="vertical">
                  <Radio key="1" value="invoice_number">Invoice Number</Radio>
                  {user?.tenant_info?.shop_name && <Radio key="2" value="shopify_order_number">Shopify Order Number</Radio>}
                </Space>
              </Radio.Group>
            </div>
          )}
          <div className="ba-input__wrapper">
            <H3Text text="Do you want to update the status of invocies?" className="ba-input__label" />
            <Radio.Group
              onChange={(event) => setStatusUpdate(event?.target?.value)}
              disabled={downloadInvoiceLoading}
              value={statusUpdate}
              style={{ marginTop: '-10px' }}
            >
              <Space direction="vertical">
                <Radio key="1" value="NO">No</Radio>
                <Radio key="2" value="YES">Yes</Radio>
              </Space>
            </Radio.Group>
          </div>
          {statusUpdate === 'YES' && (
            <div className="ba-input__wrapper">
              <H3Text text="Select Updated Status" className="ba-input__label" />
              {getDataSource(invoices?.data?.invoices)?.length > 0 && (
                <PRZSelect
                  value={selectedStatus?.custom_status_id}
                  className="filters__buttons-dropdown"
                  onChange={(value) => {
                    const possibleStatuses = [firstObject?.custom_status_info, ...firstObject?.possible_status]?.find((possibleStatus) => possibleStatus?.custom_status_id === value);
                    setSelectedStatus({
                      name: possibleStatuses?.status_name,
                      type: possibleStatuses?.type,
                      custom_status_id: possibleStatuses?.custom_status_id,
                    });
                  }}
                  disabled={!isStatusSelectEnabled || ['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name)}
                  placeholder="Select status.."
                  filterOption={false}
                >
                  {[firstObject?.custom_status_info, ...firstObject?.possible_status]
                    ?.filter((item) => (!['VOID', 'SENT_FOR_APPROVAL'].includes(selectedStatus?.type) ? !['VOID', 'SENT_FOR_APPROVAL'].includes(item?.type) : true))
                    ?.map((item) => (
                      <Option key={item?.custom_status_id} value={item?.custom_status_id}>
                        <div className="custom-status-form__color">
                          <div
                            className="custom-status-form__color-dot"
                            style={{ backgroundColor: item?.color_code }}
                          />
                          <span>{item?.status_name?.replaceAll('_', ' ')}</span>
                        </div>
                      </Option>
                    ))}
                </PRZSelect>
              )}
            </div>
          )}
          {!isStatusSelectEnabled && statusUpdate === 'YES' && !['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name) && (
            <Alert
              showIcon
              type="warning"
              message="Status of the invoices will not be updated"
              description="You have selected invoices with multiple statuses. Please add status filter or select invoices on single status only."
            />
          )}
          {['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name) && statusUpdate === 'YES' && (
            <Alert
              showIcon
              type="warning"
              message="Bulk status update not allowed"
              description="You cannot update the status of invoices in Draft or Cancelled status."
            />
          )}
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Confirm"
              onClick={() => {
                const invoiceIds = selectedRows?.map((item) => item?.invoice_id);
                const payload = {
                  invoiceIds: invoiceIds?.join(','),
                  fileType: downloadFileType,
                  sortBy: downloadSortBy,
                };
                downloadInvoice(payload, () => {
                  if (isStatusSelectEnabled && statusUpdate === 'YES' && !['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name)) {
                    const payload2 = selectedRowKeys?.map((invoiceId) => ({
                      invoice_id: invoiceId,
                      status: selectedStatus?.type,
                      secondary_status: selectedStatus?.name,
                      custom_status_id: selectedStatus?.custom_status_id,
                    }));
                    updateInvoiceStatus(payload2, () => {
                      setOpenInvoiceDownload(false);
                      callback();
                    });
                  }
                });
              }}
              isLoading={downloadInvoiceLoading}
              disabled={downloadInvoiceLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Drawer>
      <Drawer
        open={openInvoiceShippingLabels}
        onClose={() => setOpenInvoiceShippingLabels(!openInvoiceShippingLabels)}
        width="380px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '330px' }}>
            <H3Text text="Download Shipping Labels" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenInvoiceShippingLabels(false)} />
          </div>
        </div>

        <div className="ba-wrapper">
          <H3Text
            text={(
              <span>
                <FontAwesomeIcon icon={faDownload} />
            &nbsp; &nbsp;
                {`${selectedRowKeys?.length} Invoices Selected`}
              </span>
            )}
            className="ba-title"
          />
          <div className="ba-input__wrapper">
            <H3Text text="Select File Format for Downloading Shipping Label" className="ba-input__label" />
            <Radio.Group
              onChange={(event) => setShippingLabelsDownloadFileType(event?.target?.value)}
              disabled={downloadShippingLabelsLoading}
              value={shippingLabelsDownloadFileType}
              style={{ marginTop: '-10px' }}
            >
              <Space direction="vertical">
                <Radio key="1" value="pdf">Merged shipping label in single PDF</Radio>
                <Radio key="2" value="zip">Individual shipping label in Zip</Radio>
              </Space>
            </Radio.Group>
          </div>
          <div className="ba-input__wrapper">
            <H3Text text="Do you want Shipping Labels with Price?" className="ba-input__label" />
            <Radio.Group
              onChange={(event) => setWithPrice(event?.target?.value)}
              disabled={downloadShippingLabelsLoading}
              value={withPrice}
              style={{ marginTop: '-10px' }}
            >
              <Space direction="vertical">
                <Radio key="1" value="">No</Radio>
                <Radio key="2" value="true">Yes</Radio>
              </Space>
            </Radio.Group>
          </div>
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Confirm"
              onClick={() => {
                const invoiceIds = selectedRows?.map((item) => item?.invoice_id);
                const payload = {
                  invoiceIds: invoiceIds?.join(','),
                  fileType: shippingLabelsDownloadFileType,
                  WithPrice: withPrice,
                };
                downloadShippingLabels(payload.invoiceIds, payload.fileType, payload.WithPrice, () => {
                  callback();
                });
              }}
              isLoading={downloadShippingLabelsLoading}
              disabled={downloadShippingLabelsLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Drawer>
      <Drawer
        open={openBulkUpdate}
        onClose={() => setOpenBulkUpdate(!openBulkUpdate)}
        width="380px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '330px' }}>
            <H3Text text="Bulk Update Invoices" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenBulkUpdate(false)} />
          </div>
        </div>

        <div className="ba-wrapper">
          <div className="ba-input__wrapper">
            <H3Text text="Select Status" className="ba-input__label" />
            {getDataSource(invoices?.data?.invoices)?.length > 0 && (
              <PRZSelect
                value={selectedStatus?.custom_status_id}
                className="filters__buttons-dropdown"
                onChange={(value) => {
                  const possibleStatuses = [firstObject?.custom_status_info, ...firstObject?.possible_status]?.find((possibleStatus) => possibleStatus?.custom_status_id === value);
                  setSelectedStatus({
                    name: possibleStatuses?.status_name,
                    type: possibleStatuses?.type,
                    custom_status_id: possibleStatuses?.custom_status_id,
                  });
                }}
                disabled={!isStatusSelectEnabled || ['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name)}
                placeholder="Select status.."
                filterOption={false}
              >
                {[firstObject?.custom_status_info, ...firstObject?.possible_status]
                  ?.filter((item) => (!['VOID', 'SENT_FOR_APPROVAL'].includes(selectedStatus?.type) ? !['VOID', 'SENT_FOR_APPROVAL'].includes(item?.type) : true))
                  ?.map((item) => (
                    <Option key={item?.custom_status_id} value={item?.custom_status_id}>
                      <div className="custom-status-form__color">
                        <div
                          className="custom-status-form__color-dot"
                          style={{ backgroundColor: item?.color_code }}
                        />
                        <span>{item?.status_name?.replaceAll('_', ' ')}</span>
                      </div>
                    </Option>
                  ))}
              </PRZSelect>
            )}
          </div>
          {!isStatusSelectEnabled && !['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name) && (
            <Alert
              showIcon
              type="warning"
              message="Status of the invoices will not be updated"
              description="You have selected invoices with multiple statuses. Please add status filter or select invoices on single status only."
            />
          )}
          {['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name) && isStatusSelectEnabled && (
            <Alert
              showIcon
              type="warning"
              message="Bulk status update not allowed"
              description="You cannot update the status of invoices in Draft or Cancelled status."
            />
          )}
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Confirm"
              onClick={() => {
                if (isStatusSelectEnabled && !['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name)) {
                  const payload2 = selectedRowKeys?.map((invoiceId) => ({
                    invoice_id: invoiceId,
                    status: selectedStatus?.type,
                    secondary_status: selectedStatus?.name,
                    custom_status_id: selectedStatus?.custom_status_id,
                  }));
                  updateInvoiceStatus(payload2, () => {
                    setOpenBulkUpdate(false);
                    callback();
                  });
                }
              }}
              isLoading={updateInvoiceStatusLoading}
              disabled={updateInvoiceStatusLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, InvoiceReducers, CustomStatusReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getInvoiceLoading: InvoiceReducers.getInvoiceLoading,
  invoices: InvoiceReducers.invoices,
  customStatusInvoice: CustomStatusReducers.customStatusInvoice,
  downloadInvoiceLoading: InvoiceReducers.downloadInvoiceLoading,
  updateInvoiceStatusLoading: InvoiceReducers.updateInvoiceStatusLoading,
  downloadShippingLabelsLoading: InvoiceReducers.downloadShippingLabelsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getInvoice: (orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, callback) => dispatch(
    InvoiceActions.getInvoice(orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, callback),
  ),
  updateInvoiceStatus: (payload, callback) => dispatch(InvoiceActions.updateInvoiceStatus(payload, callback)),
  downloadInvoice: (payload, callback) => dispatch(InvoiceActions.downloadInvoice(payload, callback)),
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  downloadShippingLabels: (invoiceIds, fileType, withPrice, callback) => dispatch(InvoiceActions.downloadShippingLabels(invoiceIds, fileType, withPrice, callback)),
});

BulkInvoiceActions.propTypes = {
  invoices: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkInvoiceActions));
